
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1504_NRow.Fields;

    @Serenity.Decorators.registerClass()
    export class Report_1504_NGrid extends Serenity.EntityGrid<Report_1504_NRow, any> {
        protected getColumnsKey() { return Report_1504_NColumns.columnsKey; }
        protected getDialogType() { return Report_1504_NDialog; }
        protected getIdProperty() { return Report_1504_NRow.idProperty; }
        protected getInsertPermission() { return Report_1504_NRow.insertPermission; }
        protected getLocalTextPrefix() { return Report_1504_NRow.localTextPrefix; }
        protected getService() { return Report_1504_NService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

           let descriptions: string[] = [];


            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();

                let filters = Object.keys(request.EqualityFilter);

                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    // if else{
                    if (filterValue.length > 0) {
                        if (Array.isArray(filterValue)) {
                            if (quickFilter.options.lookupKey) {
                                // console.log(filterValue);
                                (filterValue as any[]).forEach(value => {
                                    var names: string[] = new Array(filterValue);
                                    for (var i = 0; i < names.length; i++) {
                                        filterValue = (names[i]);
                                        console.log(filterValue);
                                    }
                                })

                            }
                        } else {
                            filterValue
                        }
                    }
                    else {
                        filterValue = "ไม่ระบุ"
                    }
                    // }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {
                        descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                    }
                }
            }
            return [descriptions, gridColumns];
        }
        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1504_NService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานเปรียบเทียบรายเดือน ตามสินค้า'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                // 0: { field: "ShopName", title: "ร้านค้า[Id]", cellWidth: 30,isHidden:true },
                0: { field: "PluShortDesc", title: "สินค้า", cellWidth: 32,  },
                1: { field: "PluDesc", title: "รายการสินค้า", isHidden: true },
                2: { field: "Year", title: "ปี",isHidden:true},
                3: { field: "TypeSum", title: "type", cellWidth: 8},
                4: { field: "January", title: "Jan", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                5: { field: "February", title: "Feb", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                6: { field: "March", title: "Mar", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                7: { field: "April", title: "Apr", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                8: { field: "May", title: "May", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                9: { field: "June", title: "Jun", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                10: { field: "July", title: "Jul", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                11: { field: "August", title: "Aug", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                12: { field: "September", title: "Sep", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                13: { field: "October", title: "Oct", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                14: { field: "November", title: "Nov", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                15: { field: "December", title: "Dec", cellWidth: 19.75,overflow:'linebreak' ,halign: 'right',aggregate:"sum"},
                16: { field: "PluCode", title: "สินค้า", isHidden: true },
                // 10: { field: "ShopId", title: "ร้านค้า",isHidden:true},
                17: { field: "CatCode", title: "หมวดสินค้า-1", isHidden: true },
                // 12: { field: "CatName", title: "หมวดสินค้า-1", isHidden: true },
                18: { field: "SubCat1Code", title: "หมวดสินค้า-2", isHidden: true },
                // 14: { field: "SubCat1Name", title: "หมวดสินค้า-2", isHidden: true },
                19: { field: "SubCat2Code", title: "หมวดสินค้า-3", isHidden: true },
                // 16: { field: "SubCat2Name", title: "หมวดสินค้า-3", isHidden: true },
                20: { field: "BrandCode", title: "ยี่ห้อ", isHidden: true },
                // 18: { field: "BrandName", title: "ยี่ห้อ", isHidden: true },
                21: { field: "StyleId", title: "แบบ", isHidden: true },
                // 20: { field: "StyleName", title: "แบบ", isHidden: true },
                22: { field: "ColorId", title: "สี", isHidden: true },
                // 22: { field: "ColorName", title: "สี", isHidden: true },
                23: { field: "SizeId", title: "ขนาด", isHidden: true },
                // 24: { field: "SizeName", title: "ขนาด", isHidden: true },
                24: { field: "TasteId", title: "กลิ่น/รส", isHidden: true },
                // 26: { field: "TasteName", title: "กลิ่น/รส", isHidden: true },
                25: { field: "MatTypeId", title: "วัสดุที่ใช้", isHidden: true },
                // 28: { field: "MatTypeName", title: "วัสดุที่ใช้", isHidden: true },
                26: { field: "SupplId", title: "ผู้จำหน่าย", isHidden: true },
                
            }

            // buttons.push(GeniuzPOS.Common.Helpers.Report1501PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.Report1501PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
               
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }
        
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.Year).init = w => {

                (w as Serenity.StringEditor).value = Q.formatDate((new Date(Date.now())).toDateString(), "yyyy");
                
            };
            return filters;
        }
    }
}